/** Light or dark, set on the page's root element; the dark colours are in styles/variables.css. */
export function applyTheme(theme) {
  if (theme === 'dark') document.documentElement.setAttribute('data-theme', 'dark');
  else document.documentElement.removeAttribute('data-theme');
}
